import type { AxiosInstance } from 'axios'
import type { Mode } from '@/utils/api-urls'
import type { TokenDecoded } from '@/composables/workflow/useWorkflow'
import type { CustomPageLayout } from '@/views/apps/_customPage/types'
import type { Message } from './websocket/frames'
import type { ViewState } from './view-state'

export const SESSION_EXPIRED = 'SESSION_EXPIRED'

export const WORKFLOW_CANCELLED = 'WORKFLOW_CANCELLED'

export const NOTIFICATIONS_UNAVAILABLE = 'NOTIFICATIONS_UNAVAILABLE'

export const PAGE_UNAVAILABLE = 'PAGE_UNAVAILABLE'

export class UnsupportedTokenVersionError extends Error {
    version: unknown

    constructor(version: unknown) {
        super(`Unsupported t0ken version: ${String(version)}`)
        this.version = version
    }
}

export type SessionContext = {
    token: string
    decoded: TokenDecoded
    mode: Mode
}

export type ViewRef = { id: string }

export type StartOutcome = void | { locale?: string }

export type WorkflowEndReason = 'timeout' | 'cancelled'

export interface SessionStrategy {
    readonly kind: 'token-v1v2' | 'token-v3' | 'engine-v2'

    preConnect(ctx: SessionContext): Promise<void>
    validateSession(ctx: SessionContext): Promise<void>
    resolveWorkflow(ctx: SessionContext): Promise<void>
    ensureConnected(ctx: SessionContext): Promise<void>
    start(ctx: SessionContext): Promise<StartOutcome>
    awaitFirstView(ctx: SessionContext): Promise<ViewState | undefined>
    advance(ctx: SessionContext, current: ViewRef): Promise<ViewState>
    changeLanguage(ctx: SessionContext, lang: string): Promise<ViewState>
    resolveLayout(ctx: SessionContext, current: ViewRef): Promise<CustomPageLayout>
    engineApi(): AxiosInstance
    currentTaskEvents(): Message[]
    latestTaskEvent(): Message | undefined
    watchWorkflowEnd(handler: (reason: WorkflowEndReason) => void): () => void
    resetRun(): void
    disposeSession(): void
}
